import { useEffect, useState } from "react";
import { FaCircleChevronRight } from "react-icons/fa6";
import "./ViewAdditionalFieldsStyle.scss";
import AdditionalFields from "./components/AdditionalFields";
import { API_BASE_URL, apiRoutes } from "../../constants";
import Axios from "axios";

const ViewAdditionalFields = ({ profileData }) => {
  const [isOpened, setIsOpened] = useState(false);
  const [data, setData] = useState([]);

  const token = localStorage.getItem("access_token");
  const config = {
    headers: {
      Authorization: `JWT ${token}`,
      "content-type": "multipart/form-data",
    },
  };

  const getAdditionalFieldsData = () => {
    Axios.get(
      `${API_BASE_URL}${apiRoutes.additionalFields.replace(
        "{personId}",
        profileData.id
      )}`,
      config
    )
      .then((response) => {
        setData(response?.data?.data?.worker_profile ?? []);
      })
      .catch((error) => {
        console.warn(error);
        setData([]);
      });
  };

  useEffect(() => {
    getAdditionalFieldsData();
  }, [profileData?.id]);

  const handleOpen = () => {
    setIsOpened(true);
  };

  const handleClose = () => {
    setIsOpened(false);
  };

  return (
    <>
      <button
        className="see-fields-btn"
        onClick={handleOpen}
        disabled={_.isEmpty(data)}
        style={{
          cursor: _.isEmpty(data) ? "not-allowed" : "pointer",
          opacity: _.isEmpty(data) ? 0.65 : 1,
        }}
      >
        See more <FaCircleChevronRight />
      </button>
      <div
        className={`additional-fields-backdrop ${isOpened ? "open" : ""}`}
        onClick={handleClose}
      >
        <AdditionalFields data={data} handleClose={handleClose} />
      </div>
    </>
  );
};

export default ViewAdditionalFields;
